import { useAuth } from "../../contexts/AuthContext";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { Card } from "../Card";
import { useUrlParams } from "../../utils/url";
import Login from "./Login";
import Loading from "../Loading";
import HomeScreen from "./HomeScreen";

const AdminLogin = () => {
  const { isLoading } = useAuth();
  const params = useUrlParams();
  const org_id = params.org_id;

  return (
    <HomeScreen content={
      <>
        <h1 className="text-5xl font-bold mb-4">Enhance the<br />Patient Experience</h1>
        <p className="text-xl">
          Log in to access your organization's dashboard.
        </p>
      </>
    }>
      { isLoading? <Loading message="Loading..." /> :
      (
        <Card className="w-full p-8">
          <h1 className="text-4xl font-bold mb-8 text-brand-600 text-center">Admin Login</h1>
          <Login mode="admin" orgId={org_id} />
          {org_id && (
            <p className="mt-6 text-center text-sm text-gray-600">
              <a href={`/${org_id}/patient_login`} className="inline-flex items-center justify-center gap-1.5 text-brand-600 hover:underline">
                Go to Agent Login instead
                <ArrowRightIcon className="w-4 h-4" />
              </a>
            </p>
          )}
        </Card>
      )}
    </HomeScreen>
  );
};

export default AdminLogin;
